export default __webpack_public_path__ + "static/media/gameIcon.86a5f86c.svg";